import { useEffect } from "react"

import { serialize } from "@src/components/DefuseSDK/utils"
import bus, { TRACKED_EVENTS } from "@src/services/EventBus"
import { useAnalyticsSuppressed } from "./useAnalyticsSuppressed"

export function useGtagBus() {
  const suppressed = useAnalyticsSuppressed()

  useEffect(() => {
    if (!bus) return
    if (suppressed) return

    const listeners: Array<(payload: unknown) => void> = []

    for (const event of TRACKED_EVENTS) {
      const listener = (payload: unknown) => {
        try {
          window.gtag?.(
            "event",
            event,
            JSON.parse(serialize(payload as Record<string, unknown>))
          )
        } catch {
          // Analytics must never propagate exceptions
        }
      }
      listeners.push(listener)
      bus.on(event, listener)
    }

    return () => {
      if (bus) {
        for (let i = 0; i < TRACKED_EVENTS.length; i++) {
          bus.removeListener(TRACKED_EVENTS[i], listeners[i])
        }
      }
    }
  }, [suppressed])
}
